import { render } from "./Forgot.vue?vue&type=template&id=4d2aa9d7&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"

import "./Forgot.vue?vue&type=style&index=0&id=4d2aa9d7&scoped=true&lang=css"
import "./Forgot.vue?vue&type=style&index=1&id=4d2aa9d7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2aa9d7"]])

export default __exports__